
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    content: String
  }
})

export default class Confirm extends Vue {
  content!: string
}
